// extracted by mini-css-extract-plugin
export var filterIncDec = "_4j-0";
export var leftBorder = "_4j-1";
export var rightBorder = "_4j-2";
export var stringInput = "_4j-3";